import { Type } from "class-transformer";
import { ProviderAlias } from "./provider-alias";
import { Professional } from "./professional";

export class Provider
{
    constructor
    (        
        public npi: string,
        aliases: ProviderAlias[] = []
    )
    {
        this.aliases = aliases;
    }

    @Type(() => ProviderAlias)
    aliases: ProviderAlias[] = [];
}

export class ProviderLocation
{
    constructor
    (
        public locationId: number,
        public street1: string,
        public city: string,
        public state: string,
        public zipCode: string,
        public professionals: Professional[] = [],
        public street2?: string,
    )
    {}
}

export class OrganizationProvider extends Provider
{
     constructor
     (
        npi: string,
        public organizationName: string = '',
        public providerLocations: ProviderLocation[] = [],
     )
     {
        super(npi, []);
     }
}

export class ProfessionalProvider extends Provider
{
    constructor
    (
       npi: string,
       public firstName: string = '',
       public lastName: string = '',
    )
    {
       super(npi, []);
    }
}

